import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { baseApi, transformErrorResponse } from '@ibk/shared-config';
export const billetApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getBilletInfo: builder.query({
            query: ({ value }) => ({
                url: `/v1/billet`,
                params: { document: value },
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
            transformErrorResponse,
        }),
        getBilletInfoV2: builder.query({
            query: ({ value }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                return {
                    url: `/v2/billet`,
                    params: { document: value },
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
            transformErrorResponse,
        }),
        postPaymentBillet: builder.mutation({
            query: ({ body, isOperatorRequestPayment }) => {
                let baseUrl = `/v1/bankslip/pay`;
                if (isOperatorRequestPayment) {
                    baseUrl += '?usePermissions=true';
                }
                return {
                    url: baseUrl,
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                };
            },
            transformErrorResponse,
        }),
        postPaymentBankslipV2: builder.mutation({
            query: ({ body, isOperatorRequestPayment }) => {
                const partyId = getSelectedAccountInfo()?.targetId;
                let baseUrl = `/v2/bankslip/pay`;
                if (isOperatorRequestPayment) {
                    baseUrl += '?usePermissions=true';
                }
                return {
                    url: baseUrl,
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                    ...(partyId && { headers: { 'x-tr-party-selected': partyId } }),
                };
            },
            transformErrorResponse,
        }),
        postPaymentScheduleBillet: builder.mutation({
            query: ({ body, isOperatorRequestPayment }) => {
                let baseUrl = `/v1/schedule/bankslip`;
                if (isOperatorRequestPayment) {
                    baseUrl += '?usePermissions=true';
                }
                return {
                    url: baseUrl,
                    method: 'POST',
                    body,
                    forceSelectedAccountInfoAccountId: true,
                    forceAccountantApiBaseUrl: true,
                };
            },
            transformErrorResponse,
        }),
    }),
});
export const { useLazyGetBilletInfoQuery, useLazyGetBilletInfoV2Query, usePostPaymentBilletMutation, usePostPaymentBankslipV2Mutation, usePostPaymentScheduleBilletMutation, } = billetApi;
